import './index.css';
import { Navbar } from './components/Navbar';
import { Hero } from './sections/Hero';
import { RouletteSection } from './sections/RouletteSection';
import { Features } from './sections/Features';
import { HowItWorks } from './sections/HowItWorks';
import { RouletteBasics } from './sections/RouletteBasics';
import { BettingPatterns } from './sections/BettingPatterns';
import { CTA } from './sections/CTA';
import { Testimonials } from './sections/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';

function App() {
  const faqData = [
    {
      question: "What is Roulette?",
      answer: "Roulette is a classic casino game built around a numbered wheel. A ball comes to rest in one numbered pocket and that number decides the outcome of the round."
    },
    {
      question: "How does the Roulette wheel work?",
      answer: "A European Roulette wheel contains 37 pockets, numbered 0 to 36. The dealer spins the wheel in one direction and rolls a small ball in the opposite direction. Players bet on where the ball will land."
    },
    {
      question: "What are red and black bets?",
      answer: "These are 'outside bets' where you wager that the winning number will be either a red or black pocket. It pays 1:1."
    },
    {
      question: "What does zero mean?",
      answer: "The number 0 is colored green. If the ball lands on 0, all outside bets (like Red/Black, Odd/Even) usually lose, giving the house its edge."
    },
    {
      question: "Can I play the demo for free?",
      answer: "Yes, this entire platform is a free demonstration experience. No real money or deposits are required."
    },
    {
      question: "Is this real-money gambling?",
      answer: "No. Royal Roulette is purely a virtual demonstration with no real-money wagers, deposits, or withdrawals."
    },
    {
      question: "How is the result selected?",
      answer: "In this demo, the result is selected using a secure random number generator (RNG) built into the browser."
    }
  ];

  return (
    <div className="min-h-screen bg-charcoal-900 text-gray-100 font-sans selection:bg-gold-500 selection:text-white">
      <Navbar />
      
      <main>
        <Hero />
        <RouletteSection />
        <Features />
        <HowItWorks />
        <RouletteBasics />
        <BettingPatterns />
        <Testimonials />
        
        <section id="faq" className="py-24 bg-charcoal-900 border-t border-gray-800">
          <div className="container mx-auto px-4 md:px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Frequently Asked <span className="text-gold-500">Questions</span>
              </h2>
            </div>
            <FAQ questions={faqData} />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default App;
